<div id="breadcrumb">
    <div class="container">
        <div class="breadcrumb-wrapper">
            <h1>Portfolio Details</h1>
            <ul>
                <li><a href="#">Home</a></li>
                <li><i class="bi bi-chevron-double-right"></i></li>
                <li><a href="#">Portfolio Details</a></li>
            </ul>
        </div>
    </div>
</div>


<div id="portfolio-details">
    <div class="container">
        <div class="portfolio-header">
            <div class="row">
                <div class="col-md-6 col-lg-7">
                    
                </div>
                <div class="col-md-6 col-lg-5">
                    <div class="details-box">
                        <ul>
                            <li><span>Client:</span>&nbsp;&nbsp;iTech Web Solution Ltd.</li>
                            <li><span>Class:</span>&nbsp;&nbsp;Service</li>
                            <li><span>Date:</span>&nbsp;&nbsp;March 15, 2021</li>
                            <li><span>Category:</span>&nbsp;&nbsp;WordPress Theme</li>
                            <li><span>Website:</span>&nbsp;&nbsp;<a href="https://www.example.com" target="_blank">www.example.com</a></li>
                            <li><span>Value:</span>&nbsp;&nbsp;$30,000</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <div class="portfolio-content">
            <h3>Expert People Launched Quality Projects</h3>
            <p>
                At iTech Web Solution Ltd., we pride ourselves on delivering high-quality IT and consulting services tailored to the unique needs of our clients. Our team of seasoned professionals combines technical expertise with strategic insight to create innovative solutions that drive growth and efficiency. Whether it’s developing a custom WordPress theme, implementing enterprise-grade IT systems, or providing ongoing technical support, we ensure every project meets the highest industry standards.
            </p>
            <p>
                This project involved designing and launching a fully responsive and user-friendly WordPress theme for our client, optimizing it for performance, security, and SEO. We collaborated closely with the client to align the design with their brand identity, integrating advanced features such as custom plugins, content management tools, and analytics tracking. From concept to deployment, our agile approach ensured the project was delivered on time, within budget, and exceeded expectations.
            </p>
        </div>
    </div>
</div>



<footer id="footer">
    <div class="container">
        <div class="row">

            <!-- About Section -->
            <div class="col-md-6 col-lg-3">
                <div class="about">
                    <img class="logo" src="assets/icons/Transparent-2.png" alt="iTech Logo">
                    <p>
                        iTech is a leading IT solutions and consultancy provider, helping businesses
                        innovate, streamline operations, and achieve sustainable growth. From
                        software development to cloud transformation, we deliver secure, scalable,
                        and tailored solutions to meet your unique business needs.
                    </p>
                    <div class="social-icon">
                        <a href="#"><i class="bi bi-facebook"></i></a>
                        <a href="#"><i class="bi bi-twitter"></i></a>
                        <a href="#"><i class="bi bi-instagram"></i></a>
                    </div>
                </div>
            </div>

            <!-- Quick Links -->
            <div class="col-md-6 col-lg-3">
                <div class="quick-link">
                    <h4>Quick Links</h4>
                    <ul>
                        <li><a href="#">Product Design</a></li>
                        <li><a href="#">Application Development</a></li>
                        <li><a href="#">Cyber Security</a></li>
                        <li><a href="#">Data Quality Management</a></li>
                        <li><a href="#">IT Consultancy</a></li>
                        <li><a href="#">Mobile Development</a></li>
                        <li><a href="#">Cloud Migration</a></li>
                    </ul>
                </div>
            </div>

            <!-- Address -->
            <div class="col-md-6 col-lg-3">
                <div class="address">
                    <h4>Our Address</h4>
                    <img src="assets/images/img-footer-map.png" alt="Map">
                    <p>
                        <i class="bi bi-geo-alt-fill"></i>
                        <span>91 Western Road, Brighton, England</span>
                    </p>
                </div>
            </div>

            <!-- Contact Info -->
            <div class="col-md-6 col-lg-3">
                <div class="contact">
                    <h4>Contact Us</h4>

                    <div class="phone">
                        <p>
                            <i class="bi bi-telephone-fill"></i>
                            <a href="tel:+441632960896">+44 1632 960896</a>
                        </p>
                    </div>

                    <div class="email">
                        <p>
                            <i class="bi bi-envelope-fill"></i>
                            <a href="mailto:info@itech.com">info@itech.com</a>
                        </p>
                    </div>

                    <div class="subscribe">
                        <p>Subscribe to our Newsletter</p>
                        <form action="#">
                            <input type="email" placeholder="Your email" required>
                            <button type="submit"><i class="bi bi-arrow-right"></i></button>
                        </form>
                    </div>
                </div>
            </div>

        </div>

        <!-- Copyright -->
        <div class="copyright">
            <div class="left">
                <p>Copyright © 2025 iTech. All rights reserved.</p>
            </div>
            <div class="copyright-menu">
                <ul>
                    <li><a href="#">Terms & Condition</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                    <li><a href="#">Contact Us</a></li>
                </ul>
            </div>
        </div>

    </div>
</footer>


